import { render, staticRenderFns } from "./GClassManagementShowCompetencySetting.vue?vue&type=template&id=b35e9ae4&scoped=true&"
import script from "./GClassManagementShowCompetencySetting.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementShowCompetencySetting.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementShowCompetencySetting.vue?vue&type=style&index=0&id=b35e9ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e9ae4",
  null
  
)

export default component.exports